<div class="filter-node-editor" *ngIf="node">
    {{node.operator}}
</div>